module.exports = __webpack_public_path__ + "img/login-bg-left2.c9f7e232.png";